<template>
  <div class="results" v-if="resultsAvailable">
    <h3 class="display-1 primary--text mt-5 mb-5">Резултати</h3>
    <PanelsToggle
      v-model="openResults"
      :panels="questionnaire.questions.map((_,i) => i)"
    ></PanelsToggle>

    <v-expansion-panels v-model="openResults" multiple>
      <template v-for="(question, i) in questionnaire.questions">
        <v-expansion-panel
          :key="`question-results-${i}`"
          class="mt-5 mb-5"
          v-if="resultsData.length > 0 && resultsData[i].length > 0 && resultsData[i].some(r => r >0)"
        >
          <v-expansion-panel-header class="title">
            <span>
              {{ question.text }}
              <v-chip color="primary" v-if="questionnaireResults.totalVotesQuestion" small>
                {{ votedForQuestion(question.id) }}
              </v-chip>
            </span>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-divider class="mb-5"></v-divider>

            <ul class="own-answers mb-5" v-if="question.alreadyVoted">
              <li v-for="(choice, j) in question.answers" :key="`choice-${i}-${j}`">{{ ownAnswer(question, choice) }}</li>
            </ul>
            <component :is="question.results_graph" :labels="resultsLabels[i]" :data="resultsData[i]" :height="chartHeight(i)"></component>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </template>
    </v-expansion-panels>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Bar from '@/components/Charts/Bar.js'
import Pie from '@/components/Charts/Pie.js'
import Doughnut from '@/components/Charts/Doughnut.js'
import HorizontalBar from '@/components/Charts/HorizontalBar.js'
import PanelsToggle from '@/components/Buttons/PanelsToggle.vue'

export default {
  name: 'Results',

  props: {
    id: Number,
    questionnaire: Object,
  },

  components: {
    'horizontal-bar': HorizontalBar,
    'doughnut': Doughnut,
    'vertical-bar': Bar,
    'pie': Pie,
    PanelsToggle
  },

  data () {
    return {
      resultsData: [],
      resultsLabels: [],
      openResults: [],
      intervals: [],
    }
  },

  mounted () {
    this.fetchResults()
  },

  beforeDestroy() {
    for (const interval of this.intervals) {
      clearInterval(interval)
    }
  },

  computed: {
    ...mapGetters(['questionnaireResults']),
    resultsAvailable () {
      return true
      return this.questionnaire.questions.some(q => q.alreadyVoted)
    }
  },

  methods: {
    votedForQuestion (id) {
      const votes = this.questionnaireResults.totalVotesQuestion.find(q => q.question_id === id)
      return votes ? votes.total_votes : 0
    },
    fetchResults () {
      this.$store.dispatch('getResults', this.questionnaire.ID)
      const interval = setInterval(() => { this.$store.dispatch('getResults', this.questionnaire.ID) }, 5000)
      this.intervals.push(interval)
    },

    initCharts () {
      let results = {}
      this.questionnaireResults.results.forEach(r => {
        results[r.choice_id] = r.count
      })

      // extract question choice data
      this.resultsData = this.questionnaire.questions.map((q,i) => {
        this.openResults.push(i)

        return q.choices.map(c => {
          if (c.id in results) {
            return results[c.id]
          } else {
            return 0
          }
        })
      })

      // extract question choice titles
      this.resultsLabels = this.questionnaire.questions.map(q => {
        return q.choices.map(c => `${c.text} (${results[c.id] || 0})`)
      })
    },

    ownAnswer (question, choice) {
      const answer = question.choices.find(c => c.id === choice.choice_id)
      return answer ? answer.text : ''
    },

    chartHeight (i) {
      let question = this.questionnaire.questions[i]
      if (question.results_graph === 'horizontal-bar') {
        let choiceCount = question.choices.length
        return Math.ceil(choiceCount * 35)
      } else {
        return 200
      }
    }
  },

  watch: {
    'questionnaireResults': 'initCharts',
    'questionnaire': 'fetchResults'
  }
}

</script>
